import { application } from "./application"

import AssessmentController from "./assessment_controller"
application.register("assessment", AssessmentController)

import CloudinaryUploadController from "./cloudinary_upload_controller"
application.register("cloudinary-upload", CloudinaryUploadController)

import RulesFilterController from "./rules_filter_controller"
application.register("rules-filter", RulesFilterController)

import InlineToggleController from "./inline_toggle_controller"
application.register("inline-toggle", InlineToggleController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import KeyboardSaveController from "./keyboard_save_controller"
application.register("keyboard-save", KeyboardSaveController)

import AutoresizeController from "./autoresize_controller"
application.register("autoresize", AutoresizeController)

import PromptOutlineController from "./prompt_outline_controller"
application.register("prompt-outline", PromptOutlineController)

import NavKeysController from "./nav_keys_controller"
application.register("nav-keys", NavKeysController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ReviewInboxController from "./review_inbox_controller"
application.register("review-inbox", ReviewInboxController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import SubmissionsFilterController from "./submissions_filter_controller"
application.register("submissions-filter", SubmissionsFilterController)

import MediaTypePickerController from "./media_type_picker_controller"
application.register("media-type-picker", MediaTypePickerController)

import AttachmentViewerController from "./attachment_viewer_controller"
application.register("attachment-viewer", AttachmentViewerController)

import SlugSuggestController from "./slug_suggest_controller"
application.register("slug-suggest", SlugSuggestController)

import BrandLogoUploadController from "./brand_logo_upload_controller"
application.register("brand-logo-upload", BrandLogoUploadController)
